import React from 'react';
import EditComboGroupState from './editComboGroupState/EditComboGroupState';
import ControlPanel from './components/ControlPanel/ControlPanel';
import Forms from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows';

const EditComboGroupPage: React.FC = () => {
	return (
		<EditComboGroupState>
			<ControlPanel />
			<Forms />
			<ModalWindows />
		</EditComboGroupState>
	);
};

export default EditComboGroupPage;
